export default {
  teachers(state, getters, rootState, rootGetters) {
    let teachers = state.teachers || [];

    let {name} = state.filter;

    // get filtered teachers
    teachers = teachers.filter(t => {
      let teacherName = t.nickname || t.username;
      if (name && teacherName.indexOf(name) < 0) {
        return false;
      }
      return true;
    });

    // get favorite teachers from contact list
    let favoriteTeachers = new Set();
    for (let key in rootState.user.contacts) {
      if (!rootState.user.contacts.hasOwnProperty(key)) {
        continue;
      }
      let contact = rootState.user.contacts[key];
      if (contact.isFavorite) {
        favoriteTeachers.add(key);
      }
    }

    return teachers.map(t => {
      let subjects = t.metadata['科目'] || [];
      let schoolSystems = t.metadata['學制'] || [];

      subjects = subjects.map(id => {
        return {
          id: id,
          text: rootState.subjects[id] ? rootState.subjects[id].tname : ''
        };
      });

      schoolSystems = schoolSystems.map(id => {
        return {
          id: id,
          text: rootState.schoolSystems[id] ? rootState.schoolSystems[id].tname : ''
        };
      });

      return {
        id: t._id,
        avatar: t.avatar,
        years: t.metadata['年資'],
        subjects: subjects,
        schoolSystems: schoolSystems,
        gender: t.metadata['性別'] || '',
        // degree: t.metadata['學歷'],
        presence: t.presence,
        suspension: t.suspension,
        nickname: t.nickname,
        username: t.username,
        isFavorite: favoriteTeachers.has(t._id)
      };
    });
  },

  selfTeacherProfile(state, getters, rootState, rootGetters) {
    return getters.getTeacherDisplayProfile(rootState.profile);
  },

  selectedTeacherProfile(state, getters, rootState, rootGetters) {
    let teacher = state.teachers.find(t => t._id === state.selectedTeacher);
    if (!teacher) {
      return {};
    }
    return getters.getTeacherDisplayProfile(teacher);
  },

  getTeacherDisplayProfile(state, getters, rootState, rootGetters) {
    return teacherProfile => {
      if (!teacherProfile || !teacherProfile._id) {
        return {};
      }
      let subjects = teacherProfile.metadata['科目'] || [];

      let schoolSystems = teacherProfile.metadata['學制'];
      schoolSystems = schoolSystems ? [].concat(schoolSystems) : [];

      let experience = teacherProfile.metadata['教學經歷'];
      experience = experience ? [].concat(experience) : [];

      let intro = teacherProfile.metadata['個人介紹'] || '';

      subjects = subjects.map(id => {
        return rootState.subjects[id] ? rootState.subjects[id].tname : '';
      });

      schoolSystems = schoolSystems.map(id => {
        return rootState.schoolSystems[id] ? rootState.schoolSystems[id].tname : '';
      });

      let contact = rootState.user.contacts[teacherProfile._id];

      return {
        id: teacherProfile._id,
        name: teacherProfile.nickname || teacherProfile.username,
        username: teacherProfile.username,
        intro: intro,
        avatar: teacherProfile.avatar,
        degree: teacherProfile.metadata['學歷'] || '',
        subjects: subjects.join('/'),
        experience: experience,
        schoolSystems: schoolSystems.join('/'),
        isFavorite: contact ? contact.isFavorite : false
      };
    };
  },

  schoolSystemSubjectOptions(state, getters, rootState, rootGetters) {
    let schoolSystemId = state.filter.schoolSystem;
    let subjects = rootState.subjects || {};

    let result = [{text: '不限', value: null}];
    for (let key in subjects) {
      if (!subjects.hasOwnProperty(key)) {
        continue;
      }
      let subject = subjects[key];
      if (schoolSystemId && subject.schoolSystems.indexOf(schoolSystemId) < 0) {
        continue;
      }

      result.push({
        text: subject.tname,
        value: subject._id
      });
    }
    return result;
  }
};
